module.exports = __webpack_public_path__ + "img/authen_success.8c2dd5aa.png";